import { useTranslation } from 'react-i18next'
import { BookOpen } from 'lucide-react'

export function AiKnowledgeBasePage() {
    const { t } = useTranslation()

    return (
        <div className="p-6 space-y-4">
            <div className="flex items-center gap-3">
                <BookOpen className="h-8 w-8 text-muted-foreground" />
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">
                        {t('navigation.aiKnowledgeBase', 'AI Knowledge Base')}
                    </h1>
                    <p className="text-muted-foreground text-sm">
                        {t('aiKnowledgeBase.description', 'Manage AI knowledge base and documents.')}
                    </p>
                </div>
            </div>
            <div className="rounded-lg border bg-card p-6 text-muted-foreground">
                {t('aiKnowledgeBase.placeholder', 'AI Knowledge Base configuration will be available here.')}
            </div>
        </div>
    )
}
